import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { InteractiveIcon } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Typography } from '@b-stock/fe-core/design-system'
import { designColors } from '@b-stock/fe-core/theme'

export const InfoSectionContainerWithoutBorder = styled.div`
  display: grid;
  grid-template-areas:
    'icon title'
    'icon info';
  grid-gap: 0.5rem 1rem;
  grid-template-columns: 1rem minmax(0, 1fr);
  padding: 1rem;
  @media ${Breakpoints.max.small} {
    grid-gap: 0 1.5rem;
  }
`
export const InfoSectionContainerWithoutIconWithBorder = styled.div`
  display: grid;
  grid-gap: 0.5rem 1rem;
  grid-template-columns: 1rem minmax(0, 1fr);
  padding: 1rem;
  border-bottom: 0.0625rem solid ${designColors.neutral.mediumGray};
  @media ${Breakpoints.max.small} {
    grid-gap: 0 1.5rem;
  }
`
export const InfoSectionContainer = styled(InfoSectionContainerWithoutBorder)`
  border-bottom: 0.0625rem solid ${designColors.neutral.mediumGray};
`

export const GridIcon = styled(FontAwesomeIcon)`
  grid-area: icon;
  color: ${designColors.neutral.darkGray};
  font-size: 1rem;
  line-height: 1rem;
  align-self: center;
`

export const GridTitle = styled.div`
  grid-area: title;
  ${Typography.Caption}
  color: ${designColors.neutral.darkGray};
  text-transform: uppercase;
`

export const GridInfo = styled.div`
  grid-area: info;
  ${Typography.Subtitle1}
  line-height: 1.5rem;
  color: ${designColors.neutral.black};
  @media ${Breakpoints.max.small} {
    ${Typography.Subtitle2}
  }
`

const StyledInteractiveIcon = styled(InteractiveIcon)`
  font-size: 1rem;
  color: ${designColors.neutral.darkGray};

  @media ${Breakpoints.max.medium} {
    font-size: 0.75rem;
    margin-left: 1rem;
  }
`

export const DescriptionRow = ({
  icon,
  title,
  info,
  tooltipContent,
  testId,
}: {
  icon: IconDefinition
  title: React.ReactNode
  info: React.ReactNode
  tooltipContent?: React.ReactNode
  testId?: string
}) => {
  return (
    <InfoSectionContainer data-testid={testId}>
      <GridIcon icon={icon} />
      <GridTitle>
        {title}
        {tooltipContent ? (
          <StyledInteractiveIcon tooltipProps={{ hoverable: true }}>
            {tooltipContent}
          </StyledInteractiveIcon>
        ) : null}
      </GridTitle>
      <GridInfo>{info}</GridInfo>
    </InfoSectionContainer>
  )
}
